import React from 'react';
import { css } from 'aphrodite';
import { withStyles } from '@material-ui/core/styles';
import './checkbox-styles.css';
import styles from './checkbox-styles';
import MaterialCheckbox from '@material-ui/core/Checkbox';
import COLORS from '../../../library/colors';

const BlueCheckBox = withStyles({
  root: {
    color: '#c7c7c7',
    '&$checked': {
      color: COLORS.pastelBlue,
    },
  },
  checked: {},
})(props => <MaterialCheckbox color="default" {...props} />);

const Checkbox = (props) => (
  <div className={css(styles.root)}>
    <BlueCheckBox
      checked={props.checked}
      onChange={props.onChange}
      value={props.value}
      inputProps={{
        'aria-label': 'checkbox',
      }}
    />
  </div>
);

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/common/checkbox/checkbox.js